import { render, staticRenderFns } from "./iconComunUsuario.vue?vue&type=template&id=956d4578&scoped=true&"
import script from "./iconComunUsuario.vue?vue&type=script&lang=js&"
export * from "./iconComunUsuario.vue?vue&type=script&lang=js&"
import style0 from "./iconComunUsuario.vue?vue&type=style&index=0&id=956d4578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956d4578",
  null
  
)

export default component.exports